import { InterestVariableEnum } from '../../@core/@shared/domain/enums/InterestVariable.enum'

// O enum foi promovido para @shared porque a auditoria do processamento smart
// (@core/processing) precisa das mesmas variaveis. Estes dois aliases mantem o
// nome `InterestVariable` valendo tanto como valor (z.enum, InterestVariable.X)
// quanto como tipo (Record<InterestVariable, string>), sem mexer nos imports
// que ja existem.
export const InterestVariable = InterestVariableEnum
export type InterestVariable = InterestVariableEnum

export type RasterBands = Partial<Record<InterestVariable, string>>

export type Residue = {
	plantation: string
	plot: string
	actualValue: number
	estimatedValue: number
	residue: number
}

export type CalculatedVariable = {
	id: string
	forestInventoryStratumId: string
	area: number
	interestVariable: InterestVariable
	adjustedModelLatex: string
	adjustedModelCoefficients: number[]
	determinationCoefficient: number
	rootMeanSquareError: number
	meanAbsoluteError: number
	meanAbsolutePercentageError: number
	estimatedMean: number
	confidenceIntervalLowerBound: number
	confidenceIntervalUpperBound: number
	samplingError: number
	samplingErrorPercentage: number
	requiredPlots: number
	usedPlots: number
	traditionalSamplingErrorPercentage: number
	traditionalRequiredPlots: number
	plotGain: number
	residues: Residue[]
	generatedAt: string
}

export type SmartProcessingData = {
	customerId: string
	rasterIdentifier: string
	bands: RasterBands
	uncalculatedVariables: string[]
	calculatedVariables: CalculatedVariable[]
}
